module.exports = __webpack_public_path__ + "img/couple@2x.c51b37aa.png";